import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import Login from '@/components/login/login'
import Loading from '@/components/login/loading'
import Task from '@/components/task/task'
import Pickcar from '@/components/pickcar/pickcar'

import TrafficCar from '@/components/trafficCar/trafficCar'
import TrafficCarList from '@/components/trafficCar/trafficCarList'
import TrafficCarMap from '@/components/trafficCar/trafficCarMap'

import Abnormal from '@/components/abnormal/abnormal'
import Location from '@/components/location'
import Set from '@/components/set/set'
import Inplace from '@/components/inoutplace/inplace'
import Outplace from '@/components/inoutplace/outplace'

import Inlibrary from '@/components/inoutlibrary/inlibrary'
import Outlibrary from '@/components/inoutlibrary/outlibrary'
import brarylist from '@/components/inoutlibrary/brarylist'

import Movelibrary from '@/components/movelibrary/movelibrary'
import Callcar from '@/components/callcar/callcar'

import transposing from '@/components/transposing/transposing'

import maintain from '@/components/maintain/maintain'
import maintainlist from '@/components/maintain/maintainlist'
import maintainlistkids from '@/components/maintain/maintainlistkids'
import inventory from '@/components/inventory/inventory'
import inventoryList from '@/components/inventory/inventoryList'

import fill from '@/components/fill/fill'

import Maps from '@/components/maps'
import Scanning from '@/components/scanning'

import RoadFetch from '@/components/fetchcar/roadFetch'
import TransitFetch from '@/components/fetchcar/transitFetch'

import MarkVer from '@/components/verification/MarkVer'
import LiftcarVer from '@/components/verification/LiftcarVer'
import spotcheck from '@/components/spotcheck/spotcheck'
import spotchecksearch from '@/components/spotcheck/spotchecksearch'
import spotchecklist from '@/components/spotcheck/spotchecklist'
import OtherMaintenance from '@/components/maintenance/otherMaintenance'
import inflationMaintenance from '@/components/maintenance/inflationMaintenance'
import chargeMaintenance from '@/components/maintenance/chargeMaintenance'

import toDoStatistics from '@/components/toDoStatistics/toDoStatistics'
import toDoStatisticsList from '@/components/toDoStatistics/toDoStatisticsList'

import vin from '@/components/vin'




Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/loading',
      name: 'loading',
      component: Loading
    },
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/task',
      name: 'task',
      component: Task
    },
    {
      path: '/pickcar',
      name: 'pickcar',
      component: Pickcar
    },
    {
      path: '/trafficCar',
      name: 'trafficCar',
      component: TrafficCar
    },
    {
      path: '/trafficcarlist',
      name: 'trafficcarlist',
      component: TrafficCarList
    },
    {
      path: '/trafficcarmap',
      name: 'trafficcarmap',
      component: TrafficCarMap
    },
    {
      path: '/abnormal',
      name: 'abnormal',
      component: Abnormal
    },
    {
      path: '/location',
      name: 'location',
      component: Location
    },
    {
      path: '/set',
      name: 'set',
      component: Set
    },
    {
      path: '/inplace',
      name: 'inplace',
      component: Inplace
    },
    {
      path: '/outplace',
      name: 'outplace',
      component: Outplace
    },
    {
      path: '/inlibrary',
      name: 'inlibrary',
      component: Inlibrary
    },
    {
      path: '/outlibrary',
      name: 'outlibrary',
      component: Outlibrary
    },
    {
      path: '/maps',
      name: 'maps',
      component: Maps
    },
    {
      path: '/movelibrary',
      name: 'movelibrary',
      component: Movelibrary
    },
    {
      path: '/callcar',
      name: 'callcar',
      component: Callcar
    },
    {
      path: '/transposing',
      name: 'transposing',
      component: transposing
    },
    {
      path: '/maintain',
      name: 'maintain',
      component: maintain
    },
    {
      path: '/maintainlist',
      name: 'maintainlist',
      component: maintainlist
    },
    {
      path: '/maintainlistkids',
      name: 'maintainlistkids',
      component: maintainlistkids
    },
    {
      path: '/inventory',
      name: 'inventory',
      component: inventory
    },
    {
      path: '/inventoryList',
      name: 'inventoryList',
      component: inventoryList
    },
    {
      path: '/fill',
      name: 'fill',
      component: fill
    },
    {
      path: '/scanning',
      name: 'scanning',
      component: Scanning
    },
    {
      path: '/roadfetch',
      name: 'roadfetch',
      component: RoadFetch
    },
    {
      path: '/transitfetch',
      name: 'transitfetch',
      component: TransitFetch
    },
    {
      path: '/markver',
      name: 'markver',
      component: MarkVer
    },
    {
      path: '/liftcarver',
      name: 'liftcarver',
      component: LiftcarVer
    },
    {
      path: '/spotcheck',
      name: 'spotcheck',
      component: spotcheck
    },
    {
      path: '/spotchecksearch',
      name: 'spotchecksearch',
      component: spotchecksearch
    },
    {
      path: '/spotchecklist',
      name: 'spotchecklist',
      component: spotchecklist
    },
    {
      path: '/otherMaintenance',
      name: 'otherMaintenance',
      component: OtherMaintenance
    },
    {
      path: '/inflationMaintenance',
      name: 'inflationMaintenance',
      component: inflationMaintenance
    },
    {
      path: '/chargeMaintenance',
      name: 'chargeMaintenance',
      component: chargeMaintenance
    },
    {
      path: '/toDoStatistics',
      name: 'toDoStatistics',
      component: toDoStatistics
    },
    {
      path: '/toDoStatisticsList',
      name: 'toDoStatisticsList',
      component: toDoStatisticsList
    },
    {
      path: '/vin',
      name: 'vin',
      component: vin
    },
    {
      path: '/brarylist',
      name: 'brarylist',
      component: brarylist
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js